import {initializeApp} from "firebase/app"
import { getAuth,GoogleAuthProvider } from "firebase/auth";


const firebaseConfig = {
  apiKey: "AIzaSyB7_mQuVbOtI5PBcYkcUMUNSqWklRwTePI",
  authDomain: "kingster-374a7.firebaseapp.com",
  projectId: "kingster-374a7",
  storageBucket: "kingster-374a7.firebasestorage.app",
  messagingSenderId: "190272093682",
  appId: "1:190272093682:web:0cb7f1dc9bc559ff3b3f6b"
};


const app = initializeApp(firebaseConfig);

export const auth = getAuth(app)